import React from 'react';
import {
  mergeClasses, Switch, SwitchProps, Label, useId,
} from '@fluentui/react-components';
import { useDataSelection } from '@bingads-webui-react/data-selection';

import { I18n } from '../types';
import { useSelectOnlySwitchStyles } from './select-only-switch-styles';

interface SelectOnlySwitchProps {
  i18n: I18n;
  className?: string;
  label?: string;
  showSelectedOnly: boolean;
  showTotalSelectedCount?: boolean;
  labelPositionleft?: boolean,
}

export const SelectOnlySwitch: React.FC<(SelectOnlySwitchProps & SwitchProps)> = ({
  i18n, className, showSelectedOnly, onChange, showTotalSelectedCount, label, labelPositionleft,
}) => {
  const {
    dataSelection,
  } = useDataSelection();
  const classes = useSelectOnlySwitchStyles();
  const computedLabel = label || i18n.getString(_TL_('Show selected')) + (showTotalSelectedCount ? ` (${dataSelection && dataSelection.length})` : '');
  const switchId = useId('selectonly-switch');

  return (
    <div className={mergeClasses('show-select-control', classes.root, className)}>
      {labelPositionleft && <Label htmlFor={switchId}>{computedLabel}</Label>}
      <Switch
        id={switchId}
        label={!labelPositionleft && computedLabel}
        checked={showSelectedOnly}
        onChange={onChange}
      />
    </div>
  );
};
